import React from 'react';
import fondo from './Artes-Vectores-tablitas.png'
import { useNavigate } from 'react-router-dom'

function Header() {

  const navigate= useNavigate()
  function miFunc() {
    navigate('/login')
  }

  return (
      <header>
        <img src={fondo} alt=""/>
        <a className="IdBotonLogin" onClick={miFunc}> Login </a>
        </header>
  )
}

export default Header
/*<img src={fondo} alt=""/>*/